import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
// import StateSynchronizer from '../../../../../utils/StateSynchronizer';

class ExchangeRateGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.exchangeRateMetaGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100
      },
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.closeToolPanel();

    // const COLUMNS_KEY = 'trade--report-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      exchangeRateArray,
      className = 'grid-wrapper',
      loadExchangeRateActionStatus
    } = this.props;

    const isLoading = loadExchangeRateActionStatus === ACTION_STATUS.LOGINING;
    if (loadExchangeRateActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadExchangeRateActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={exchangeRateArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            rowClassRules={this.state.rowClassRules}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            resizable={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default ExchangeRateGrid;